export default {
  heading: 'Sharing their location',
  badgeLive: 'Live',
  badgeOnce: 'Shared',
  badgeQuiet: 'No recent update',
  liveUntil: 'Sharing live until {time}.',
  liveOpen: 'Sharing live until they stop.',
  onceLine: 'Shared their location {ago}. It stays visible for 30 minutes.',
  updated: 'Last update {ago}.',
  note: "They chose to share this from the app. Only their latest position is kept. Crew on a site they're rostered to can see it on that site's map.",
}
